// FLAGS: silent-failure
// The timezone primitives the booking and reschedule flows depend on. Both failures they cause are recorded in
// views/sessions/MODULE.md — the operator's browser zone becoming the client's booked zone, and a picker label
// naming a zone other than the one being booked. Change either and re-read that doc first.
import moment from "moment";

export const getPsychologistTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// FLAGS: silent-failure
// When the requested zone is absent from the server list this returns a different zone with the nearest current
// UTC offset and reports it as a match. Offsets are read at "now", so two zones that agree today diverge across a
// DST boundary. Its callers use the result for display; feeding it into a booking payload would move the slot.
export const findClosesTimezoneInListForSpecificTimezone = (
  timezones,
  specificTimezone,
) => {
  let closestTimezone = timezones.find((x) => x.zoneId === specificTimezone);
  if (!closestTimezone) {
    // find closest timezone by UtcOffsetInMinutes
    const utcOffsetInMinutes = getUtcOffsetInMinutes(specificTimezone);

    closestTimezone = timezones.reduce((prev, current) => {
      return Math.abs(current.utcOffsetInMinutes - utcOffsetInMinutes) <
        Math.abs(prev.utcOffsetInMinutes - utcOffsetInMinutes)
        ? current
        : prev;
    });
  }
  return closestTimezone;
};

export const getUtcOffsetInMinutes = (timezone) => {
  const zone = moment.tz(timezone);
  return zone.utcOffset();
};
